// extracted by mini-css-extract-plugin
export var box = "_1n-1";
export var checked = "_1n-2";
export var descriptionSpacer = "_1n-9";
export var disabled = "_1n-3";
export var icon = "_1n-6";
export var input = "_1n-0";
export var labelSpacer = "_1n-8";
export var medium = "_1n-5";
export var small = "_1n-4";
export var text = "_1n-7";